import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function Home() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="home-page">
      <section className="home-hero">
        <h1>Event Manager</h1>
        <p className="home-tagline">Organize and manage your events in one place.</p>
        <div className="home-actions">
          <Link to="/events" className="btn btn-primary">Browse Events</Link>
          {!isAuthenticated && (
            <>
              <Link to="/signin" className="btn btn-secondary">Sign In</Link>
              <Link to="/signup" className="btn btn-secondary">Sign Up</Link>
            </>
          )}
        </div>
      </section>
      <section className="home-features">
        <h2>What you can do</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>Create Events</h3>
            <p>Add new events with title, description, date and category.</p>
          </div>
          <div className="feature-card">
            <h3>Manage Events</h3>
            <p>Edit and delete your events anytime.</p>
          </div>
          <div className="feature-card">
            <h3>Stay Organized</h3>
            <p>Keep track of all your events in one simple interface.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
